import React, { useEffect } from 'react'
import {connect} from 'react-redux'
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import {Container,Row,Col} from 'reactstrap'


import {setCurrenttab_About} from '../../Actions/Actionexport'
import Authorimage from '../../Resources/Images/20200417_141804_compress44.jpg'


const useStyles = makeStyles({
    root: {
      maxWidth: 400,
    },
    media: {
      height: 500,
    },
  });

const About=(props)=>{
    const classes = useStyles();

    useEffect(()=>{
      props.setCurrenttab_About()
    },[props])

    return(<Container  >
<Row className="mt-5  " lg='2' xs='1'>
    <Col>
    <Card className={classes.root}>
      <CardActionArea>
        <CardMedia
          className={classes.media}
          image={Authorimage}
          title="Contemplative Reptile"
        />
       </CardActionArea>
    </Card>
    </Col>
    <Col className="mt-5 ">
    <Card className={classes.root}>
    <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
           Who am i ?
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
          Hi, I am a professional full-stack web developer working in leading software industries. 
          Having 3 years of experience. As a hobby, I developed an android game in unity and released in the play store.
           And also interested in 2d-animation and digital art using adobe products.
            I love coding and developing a web application .
          
          </Typography>
        </CardContent>
    </Card>
    </Col>
</Row>
    
       <hr></hr>
    </Container>
    )
}
const mapdispatchtomethod=(dispatch)=>{
    return{
        setCurrenttab_About:()=>dispatch(setCurrenttab_About())
    }
}
export default connect(null,mapdispatchtomethod)(About) 